export enum TipoCadastro {
    TODOS = 'TODOS',
    CLIENTES = 'CLIENTES',
    FORNECEDORES = 'FORNECEDORES',
    PRODUTORES = 'PRODUTORES',
    SINDICATO = 'SINDICATO',
    VENDEDORES = 'VENDEDORES',
    TRANSPORTADORES = 'TRANSPORTADORES',
    MOTORISTAS = 'MOTORISTAS',
    FUNCIONARIOS = 'FUNCIONARIOS',
    TECNICOS = 'TECNICOS',
    TRABALHADORES = 'TRABALHADORES',
}
